import Vue from "vue";
import router from '@/router'
import { getToken, removeToken } from '@/utils/auth'
import {
    Dialog,
} from "vant";
Vue.use(Dialog);
function parseTime(time) {
    if (time) {
        var date = new Date(time)
        var year = date.getFullYear()
        /* 在日期格式中，月份是从0开始的，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        // 拼接
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    } else {
        return ''
    }
}

export function getDepNameByDomain() {
    if (process.env.NODE_ENV === "development") return "csqfpt";
    return window.location.hostname.split(".")[0];
  }




export function simpleUuid() {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = ''

    var uuid = s.join('')
    return uuid
}

// 将四个全局公共方法，组合成一个对象，并暴露出去
export default {
    parseTime,
}


// WEBPACK FOOTER //
// ./src/utils/index.js